import PropTypes from 'prop-types'
import React from 'react'

const LabelWithToolTip = ({ label, tooltipText, children, shouldHideDebitCardOption = false }) => (
  <>
    <div className="label">
      {label}

      {(tooltipText && !shouldHideDebitCardOption) && (
        <div className="tooltip-container">
          <span className="tooltip-icon">?</span>
          <span className="tooltip-text"> {tooltipText}</span>
        </div>
      )}
    </div>
    {children}
  </>
)


LabelWithToolTip.propTypes = {
  label: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
  children: PropTypes.node.isRequired,
  shouldHideDebitCardOption: PropTypes.bool
}

export default LabelWithToolTip
